var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Order } from '../data/order';
import { OrderItemBuilder } from '../base/orderitem-builder';
import { OrderItem } from '../data/order-item';
import { MathUtils } from '../utility/math-utils';
import { UUID } from 'angular2-uuid';
import { Discount } from "../data/discount";
import { Condition } from "../data/condition";
import { Benefit } from "../data/benefit";
import { EventEmitter, Injectable } from "@angular/core";
import { Subject } from 'rxjs';
/**
 * Manage order's data(items, discounts, calculation, etc.)
 * Manage order's life cycle (create, update, clear)
 * **/
var OrderManager = /** @class */ (function () {
    function OrderManager() {
        this.count = 0;
        this.total = 0;
        //cache of main item quantities
        this.quantities = {};
        this.stores = [];
        this.onOrderitemsChange = new EventEmitter();
        this.$itemChange = new Subject();
        this.letter = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    }
    OrderManager.prototype.getOrder = function () {
        return this.order;
    };
    OrderManager.prototype.setOrder = function (order) {
        this.order = order;
        this.calculate();
    };
    OrderManager.prototype.createOrder = function (storeId, takeout, orderId, type, store, session) {
        if (takeout === void 0) { takeout = false; }
        if (orderId === void 0) { orderId = null; }
        if (type === void 0) { type = null; }
        if (store === void 0) { store = null; }
        this.order = new Order();
        if (store) {
            this.store = store;
        }
        console.log("creating order");
        this.order.storeId = storeId;
        this.order.orderitems = [];
        this.order.takeout = takeout;
        this.order.id = orderId;
        this.order.uuid = UUID.UUID().toString();
        if (store) {
            this.order.brandId = store.brandId;
        }
        this.order.type = type;
        this.order.sourceUrl = window.location.href;
        if (session) {
            this.order.session = session;
        }
        console.log("takeout", this.order.takeout);
        if (this.member) {
            this.order.member = this.member;
        }
        else { //storellet non-member promotion info
            if (store && store['crm']) {
                var crm = store['crm'];
                this.order.extra = {};
                this.order.extra["crm"] = {};
                if (crm["extra"]) {
                    this.order.extra["crm"] = crm["extra"];
                }
                if (store["crmId"]) {
                    this.order.extra["crm"]["crmStoreId"] = store["crmId"];
                }
                if (crm["type"]) {
                    this.order.extra["crm"]["type"] = crm["type"];
                }
            }
        }
        if (this.member && this.member.backendId) {
            this.order.memberNumber = Number(this.member.backendId); //Yoshinoya member
        }
        if (store && store.menu)
            this.setDiscounts(store.menu); //CMS discounts
        this.upselling = true;
    };
    // DANGER: should change orderManager.mode as well
    // takeoutChange(takeout: boolean) {
    //     this.order.takeout = takeout;
    // }
    OrderManager.prototype.setUserPoints = function (member) {
        if (!this.order || !member || !member["membership"])
            return;
        var points = member.membership.usablePoints;
        if (points) {
            this.order.usablePoints = points;
        }
    };
    OrderManager.prototype.setBrandId = function (id) {
        if (this.order)
            this.order.brandId = id;
    };
    OrderManager.prototype.setDiscounts = function (menu) {
        var _this = this;
        var discounts = [];
        if (menu.discounts) {
            discounts = menu.discounts;
        }
        this.order.promotions = [];
        discounts.forEach(function (d) {
            var promo = new Discount();
            promo.level = d.level;
            promo.benefits = [];
            if (d.benefits) {
                d.benefits.forEach(function (b) {
                    if (b.type == "unlock" && menu.unlocks)
                        promo.unlocks = menu.unlocks;
                    if (b.type == "gift" && menu.gifts)
                        promo.gifts = menu.gifts;
                    promo.benefits.push(Benefit.cloneBenefit(b));
                });
            }
            promo.conditions = [];
            if (d.conditions) {
                d.conditions.forEach(function (c) {
                    promo.conditions.push(Condition.cloneCondition(c));
                });
            }
            promo.name = d.name;
            promo.amount = d.amount;
            promo.available = d.available;
            promo.backendId = d.backendId;
            promo.id = d.id;
            promo.enabled = d.enabled;
            promo.desc = d.desc;
            promo.quantity = d.quantity;
            promo.backendType = d.backendType;
            _this.order.promotions.push(promo);
        });
    };
    OrderManager.prototype.setNewDiscounts = function (discounts, menu) {
        var _this = this;
        this.order.promotions = [];
        discounts.forEach(function (d) {
            var promo = new Discount();
            promo.level = d.level;
            promo.benefits = [];
            if (d.benefits) {
                d.benefits.forEach(function (b) {
                    if (menu && b.type == "unlock" && menu.unlocks)
                        promo.unlocks = menu.unlocks;
                    if (menu && b.type == "gift" && menu.gifts)
                        promo.gifts = menu.gifts;
                    promo.benefits.push(Benefit.cloneBenefit(b));
                });
            }
            promo.conditions = [];
            if (d.conditions) {
                d.conditions.forEach(function (c) {
                    promo.conditions.push(Condition.cloneCondition(c));
                });
            }
            promo.name = d.name;
            promo.amount = d.amount;
            promo.available = d.available;
            promo.backendId = d.backendId;
            promo.id = d.id;
            promo.enabled = d.enabled;
            promo.desc = d.desc;
            promo.quantity = d.quantity;
            _this.order.promotions.push(promo);
        });
    };
    OrderManager.prototype.calcDiscountGrandTotal = function (order) {
        this.calculateOrder(order);
        // this.order.grandTotal = MathUtils.round(this.order.total + this.order.handling + this.order.exTax - this.order.discount, 2);
    };
    OrderManager.prototype.calcOrderSafe = function (order, store) {
        this.calculateOrderSafe(order, store, false);
    };
    OrderManager.prototype.setStores = function (stores, masterId) {
        this.stores = stores;
        if (this.order)
            this.order.multi = true;
        if (masterId)
            this.master = this.getStore(masterId);
    };
    OrderManager.prototype.setNoUpselling = function () {
        this.upselling = false;
    };
    OrderManager.prototype.setMember = function (member) {
        this.member = member;
        if (this.order) {
            this.order.member = member;
            if (member.backendId) {
                this.order.memberNumber = Number(member.backendId); //Yoshinoya
            }
        }
        console.log("set member:", member);
    };
    OrderManager.prototype.setDiscountCode = function (code) {
        this.order.promoCode = code;
    };
    OrderManager.prototype.setPromoCode = function (code) {
        this.order.promoCode = code;
    };
    OrderManager.prototype.setSeats = function (seats) {
        this.order.seats = seats;
    };
    OrderManager.prototype.setSource = function (source) {
        this.order.source = source;
    };
    OrderManager.prototype.isUsablePointsEnough = function (item) {
        var usablePoints = this.order ? this.order.usablePoints : 0;
        var usedPoints = this.order ? this.order.usedPoints : 0;
        var points = item ? item.points : 0;
        return usablePoints >= usedPoints + item.points;
    };
    //APPROVED
    OrderManager.prototype.refreshOrderItem = function (orderitem) {
        OrderItem.flattenItems(orderitem);
        this.calculateOrderItem(orderitem);
        this.calculateOrder(this.order);
        console.log(this.order);
    };
    //APPROVED
    OrderManager.prototype.addOrderItem = function (orderitem, isRecom) {
        if (isRecom === void 0) { isRecom = false; }
        if (!this.isUsablePointsEnough(orderitem))
            return;
        OrderItem.flattenItems(orderitem);
        orderitem.setRecommended(isRecom);
        this.order.orderitems.push(orderitem);
        this.calculateOrderItem(orderitem);
        this.calculateOrder(this.order);
        console.log("addOrderItem", this.order);
    };
    //APPROVED
    OrderManager.prototype.addExistingOrderItem = function (orderitem) {
        if (!this.isUsablePointsEnough(orderitem))
            return;
        orderitem.quantity++;
        this.calculateOrderItem(orderitem);
        this.calculateOrder(this.order);
        console.log(this.order);
    };
    //APPROVED
    OrderManager.prototype.duplicateOrderItem = function (orderitem) {
        if (!this.isUsablePointsEnough(orderitem))
            return;
        var oi = OrderItemBuilder.cloneOrderItem(orderitem, true);
        this.addOrderItem(oi);
        return oi;
    };
    //APPROVED
    OrderManager.prototype.replaceOrderItem = function (old, oi) {
        old.groups = oi.groups;
        old.quantity = 1;
        OrderItem.flattenItems(old);
        this.calculateOrderItem(old);
        this.calculateOrder(this.order);
        console.log(this.order);
        this.$itemChange.next({ orderItem: oi, type: 'edit' });
    };
    OrderManager.prototype.createOrderItem = function (category, itemgroup, item) {
        var builder = new OrderItemBuilder(this.store);
        builder.setCategory(category);
        builder.setItem(itemgroup, item, 0);
        var oi = builder.build();
        return oi;
    };
    //APPROVED
    OrderManager.prototype.addSingleItem = function (category, itemgroup, item, ignoreModifiers, isRecom) {
        if (ignoreModifiers === void 0) { ignoreModifiers = true; }
        if (isRecom === void 0) { isRecom = false; }
        if (!this.isUsablePointsEnough(item))
            return;
        var orderitem = this.findOrderItem(item, ignoreModifiers);
        if (!orderitem) {
            var builder = new OrderItemBuilder(this.store);
            builder.setCategory(category);
            builder.setItem(itemgroup, item, 0);
            var oi = builder.build();
            this.addOrderItem(oi, isRecom);
            this.$itemChange.next({ orderItem: oi, type: 'add' });
            return oi;
        }
        else {
            orderitem.quantity++;
            this.calculateOrderItem(orderitem);
            this.calculateOrder(this.order);
            this.$itemChange.next({ orderItem: orderitem, type: 'add' });
            return orderitem;
        }
    };
    OrderManager.prototype.minusItem = function (item, ignoreModifiers) {
        if (ignoreModifiers === void 0) { ignoreModifiers = true; }
        var orderitem = this.findOrderItem(item, ignoreModifiers);
        if (orderitem) {
            this.minusOrderItem(orderitem);
            this.$itemChange.next({ orderItem: orderitem, type: 'delete' });
        }
    };
    OrderManager.prototype.minusOrderItem = function (orderitem) {
        if (orderitem) {
            orderitem.quantity--;
            if (orderitem.quantity <= 0) {
                this.removeObject(orderitem, this.order.orderitems);
            }
            this.calculateOrder(this.order);
        }
    };
    OrderManager.prototype.findOrderItem = function (item, ignoreModifiers) {
        if (ignoreModifiers === void 0) { ignoreModifiers = true; }
        for (var _i = 0, _a = this.order.orderitems; _i < _a.length; _i++) {
            var oi = _a[_i];
            var groups = oi.groups;
            if (groups.length == 1) {
                var items = groups[0].items;
                if (item.id == items[0].id) {
                    if (ignoreModifiers) {
                        return oi;
                    }
                    else {
                        var mgroups = items[0].mgroups;
                        if (!mgroups || mgroups.length == 0) {
                            return oi;
                        }
                    }
                }
            }
        }
        return null;
    };
    OrderManager.prototype.getQuantity = function (item) {
        var result = this.quantities[item.id];
        if (!result)
            result = 0;
        return result;
    };
    OrderManager.prototype.calculate = function () {
        this.calculateOrder(this.order);
    };
    OrderManager.prototype.getOfferItemPriceSafe = function () {
        var price = 0;
        if (this.order && this.order.offers) {
            for (var _i = 0, _a = this.order.offers; _i < _a.length; _i++) {
                var offer = _a[_i];
                for (var _b = 0, _c = offer.orderitems; _b < _c.length; _b++) {
                    var orderItem = _c[_b];
                    price = price + orderItem.total;
                }
            }
        }
        price = MathUtils.round(price, 2);
        return price;
    };
    OrderManager.prototype.settingOrderType = function (type) {
        if (!this.order)
            return;
        this.order.type = type;
        this.order.takeout = type == "takeaway";
    };
    OrderManager.prototype.isTakeout = function () {
        return this.mode === "takeaway";
    };
    OrderManager.prototype.isEmpty = function () {
        if (!this.order || !this.order.orderitems)
            return true;
        return this.order.orderitems.length == 0;
    };
    OrderManager.prototype.clear = function () {
        this.order = null;
        this.count = 0;
        this.total = 0;
        this.quantities = {};
        this.member = null;
        this.users = null;
        this.mode = this.initMode;
        if (this.listener) {
            this.listener.onOrderChanged(this.order);
        }
    };
    OrderManager.prototype.clearOrderItems = function () {
        this.order.orderitems = [];
        this.calculate();
        if (this.listener) {
            this.listener.onOrderChanged(this.order);
        }
        this.$itemChange.next(null);
    };
    OrderManager.prototype.getStore = function (storeId) {
        var t = this.store;
        if (this.stores) {
            for (var _i = 0, _a = this.stores; _i < _a.length; _i++) {
                var store = _a[_i];
                if (store.id == storeId) {
                    t = store;
                    break;
                }
            }
        }
        return t;
    };
    OrderManager.prototype.getMultiOrders = function (order, masterId) {
        var _this = this;
        if (!order.multi)
            return [order];
        else {
            var index_1 = 0;
            var t_1 = JSON.parse(JSON.stringify(order));
            t_1.orderitems = [];
            var result_1 = new Map();
            order.orderitems.forEach(function (oi) {
                if (result_1 && result_1.has(oi.storeId)) {
                    var temp_1 = result_1.get(oi.storeId);
                    temp_1.orderitems.push(oi);
                    console.log("push updated order", temp_1);
                    result_1.set(oi.storeId, temp_1);
                }
                else {
                    var temp_2 = JSON.parse(JSON.stringify(t_1));
                    temp_2.backendId = temp_2.orderNo;
                    temp_2.orderNo = _this.getOrderNumber(temp_2.orderNo, index_1);
                    temp_2.orderitems.push(oi);
                    temp_2.storeId = oi.storeId;
                    temp_2.uuid = UUID.UUID().toString();
                    console.log("push order", temp_2);
                    result_1.set(oi.storeId, temp_2);
                    index_1++;
                }
            });
            var temp_3 = [];
            var i_1 = 0;
            result_1.forEach(function (order) {
                var master = _this.getStore(masterId);
                var store = _this.getStore(order.storeId);
                var first = i_1 == 0;
                order = _this.calculateOrderSafe(order, master, first);
                order.printers = store.printers;
                temp_3.push(order);
                i_1++;
            });
            console.log("multi Order return,", temp_3);
            return temp_3;
        }
    };
    OrderManager.prototype.isOnlyPointsItem = function () {
        var orderItems = (this.order && this.order.orderitems) || [];
        if (orderItems.length == 0)
            return false;
        var result = orderItems.some(function (oi) {
            if (!oi || !oi.categoryType || oi.categoryType != 'points') {
                return true;
            }
        });
        return !result;
    };
    //calculate the net total need to pay
    OrderManager.prototype.getNetAmount = function () {
        var result = 0;
        var master = this.getMasterStore();
        var settings = this.store.menu.settings;
        if (settings && settings.checkoutTrimDecimals) {
            result = MathUtils.round(this.order.grandTotal - this.pointsFactor * this.order.usedPoints, settings.checkoutTrimDecimalsPlace);
        }
        else {
            var p = this.getStoreGrandTotalPrecision(master.currency);
            result = MathUtils.round(this.order.grandTotal - this.pointsFactor * this.order.usedPoints, p);
        }
        if (settings && settings.checkoutTrimDecimalsMode) {
            if (this.store.menu.settings.checkoutTrimDecimalsMode === "rounddown") {
                result = Math.floor(this.order.grandTotal - this.pointsFactor * this.order.usedPoints);
            }
        }
        return result;
    };
    OrderManager.prototype.removeObject = function (object, array) {
        var idx = array.indexOf(object);
        if (idx != -1) {
            array.splice(idx, 1);
        }
    };
    OrderManager.prototype.calculateOrder = function (order) {
        var count = 0;
        var total = 0;
        var usedPoints = 0;
        var quantities = {};
        console.log("calculate order", this.order);
        for (var _i = 0, _a = this.order.orderitems; _i < _a.length; _i++) {
            var oi = _a[_i];
            if (!OrderItem.isSet(oi)) {
                count += oi.quantity;
                var t = oi.quantity * oi.total;
                total += MathUtils.round(t, 2);
                var mainItemId = oi.items[0].id;
                var quantity = quantities[mainItemId];
                if (!quantity)
                    quantity = 0;
                quantity += oi.quantity;
                quantities[mainItemId] = quantity;
            }
            else {
                count += oi.quantity;
                var t = oi.quantity * oi.total;
                total += MathUtils.round(t, 2);
            }
            // oi.points is not used in byod v2
            usedPoints += (oi.points * oi.quantity);
        }
        total = MathUtils.round(total, 2);
        this.count = count;
        this.total = total;
        this.quantities = quantities;
        this.order.grandTotal = total;
        this.order.total = total;
        if (!this.order.discount)
            this.order.discount = 0;
        this.order.handling = this.getHandling();
        // this.order.usedPoints = usedPoints;
        this.calcGrandTotal();
        this.order.serviceCharge = this.getServiceCharge();
        this.order.tax = this.getTax();
        //regenerate uuid, meaning the order is changed
        this.order.uuid = UUID.UUID().toString();
        console.log("listener", this.listener);
        if (this.listener) {
            this.listener.onOrderChanged(this.order);
        }
        this.onOrderitemsChange.emit("order change");
    };
    OrderManager.prototype.calculateOrderSafe = function (order, store, first) {
        var count = 0;
        var total = 0;
        var quantities = {};
        console.log("calculate order", order);
        for (var _i = 0, _a = order.orderitems; _i < _a.length; _i++) {
            var oi = _a[_i];
            if (!OrderItem.isSet(oi)) {
                count += oi.quantity;
                var t = oi.quantity * oi.total;
                total += MathUtils.round(t, 2);
                var mainItemId = oi.items[0].id;
                var quantity = quantities[mainItemId];
                if (!quantity)
                    quantity = 0;
                quantity += oi.quantity;
                quantities[mainItemId] = quantity;
            }
            else {
                count += oi.quantity;
                var t = oi.quantity * oi.total;
                total += MathUtils.round(t, 2);
            }
        }
        total = MathUtils.round(total, 2);
        order.grandTotal = total;
        order.total = total;
        if (!order.discount)
            order.discount = 0;
        // order.handling = this.getHandlingSafe(order, store, first);
        // order.grandTotal = MathUtils.round(order.total + order.handling - order.discount, 2);
        // order.tax = this.getTaxSafe(order, store);
        //regenerate uuid, meaning the order is changed
        order.uuid = UUID.UUID().toString();
        // console.log("listener", this.listener);
        // if (this.listener) {
        //     this.listener.onOrderChanged(this.order);
        var master = this.getMasterStore();
        var settings = store.menu.settings;
        var p = this.getStoreGrandTotalPrecision(master.currency);
        var taxExclusiveAmount = 0;
        if (order && order.taxes && order.taxes.length > 0) {
            order.taxes.forEach(function (taxR) {
                if (!taxR.inclusive) {
                    taxExclusiveAmount += taxR.amount;
                }
            });
        }
        else {
            taxExclusiveAmount = order.tax;
        }
        var rawGrandTotal = this.getSafeNum(order.total) - this.getSafeNum(order.discount) + this.getSafeNum(order.handling) + this.getSafeNum(order.serviceCharge) + this.getSafeNum(taxExclusiveAmount) + this.getSafeNum(order.shipping);
        if (settings && settings.checkoutTrimDecimals && settings.checkoutTrimDecimalsMode) {
            var precision = this.store.menu.settings.checkoutTrimDecimalsPlace;
            if ((typeof precision) !== 'number') {
                precision = this.getStoreGrandTotalPrecision(master.currency);
            }
            if (store.menu.settings.checkoutTrimDecimalsMode === "rounddown") {
                order.grandTotal = MathUtils.floor(rawGrandTotal, precision);
            }
            else if (store.menu.settings.checkoutTrimDecimalsMode === "roundup") {
                order.grandTotal = MathUtils.ceil(rawGrandTotal, precision);
            }
            else if (store.menu.settings.checkoutTrimDecimalsMode === "roundhalfup") {
                order.grandTotal = MathUtils.round(rawGrandTotal, precision);
            }
            else if (store.menu.settings.checkoutTrimDecimalsMode === 'roundtonear5') {
                order.grandTotal = MathUtils.roundToNearest5(rawGrandTotal, precision);
            }
            else {
                console.warn('invalid checkoutTrimDecimalsMode setting', this.store.menu.settings);
                order.grandTotal = MathUtils.round(rawGrandTotal, precision);
            }
        }
        else {
            order.grandTotal = MathUtils.round(rawGrandTotal, p);
        }
        order.grandTotal = order.grandTotal > 0 ? order.grandTotal : 0;
        return order;
    };
    OrderManager.prototype.calcGrandTotal = function () {
        var master = this.getMasterStore();
        var settings = this.store.menu.settings;
        var p = this.getStoreGrandTotalPrecision(master.currency);
        var taxExclusiveAmount = 0;
        if (this.order && this.order.taxes && this.order.taxes.length > 0) {
            this.order.taxes.forEach(function (taxR) {
                if (!taxR.inclusive) {
                    taxExclusiveAmount += taxR.amount;
                }
            });
        }
        else {
            taxExclusiveAmount = this.order.tax;
        }
        var rawGrandTotal = this.getSafeNum(this.order.total) - this.getSafeNum(this.order.discount) + this.getSafeNum(this.order.handling) + this.getSafeNum(this.order.serviceCharge) + this.getSafeNum(taxExclusiveAmount) + this.getSafeNum(this.order.shipping);
        if (settings && settings.checkoutTrimDecimals && settings.checkoutTrimDecimalsMode) {
            var precision = this.store.menu.settings.checkoutTrimDecimalsPlace;
            if ((typeof precision) !== 'number') {
                precision = this.getStoreGrandTotalPrecision(master.currency);
            }
            if (this.store.menu.settings.checkoutTrimDecimalsMode === "rounddown") {
                //this.order.discount = Math.floor(this.order.discount);
                this.order.grandTotal = MathUtils.floor(rawGrandTotal, precision);
            }
            else if (this.store.menu.settings.checkoutTrimDecimalsMode === "roundup") {
                this.order.grandTotal = MathUtils.ceil(rawGrandTotal, precision);
            }
            else if (this.store.menu.settings.checkoutTrimDecimalsMode === "roundhalfup") {
                this.order.grandTotal = MathUtils.round(rawGrandTotal, precision);
            }
            else if (this.store.menu.settings.checkoutTrimDecimalsMode === 'roundtonear5') {
                this.order.grandTotal = MathUtils.roundToNearest5(rawGrandTotal, precision);
            }
            else {
                console.warn('invalid checkoutTrimDecimalsMode setting', this.store.menu.settings);
                this.order.grandTotal = MathUtils.round(rawGrandTotal, precision);
            }
        }
        else {
            this.order.grandTotal = MathUtils.round(rawGrandTotal, p);
        }
        this.order.grandTotal = this.order.grandTotal > 0 ? this.order.grandTotal : 0;
    };
    OrderManager.prototype.getSafeNum = function (value) {
        return (isNaN(value) || value === null) ? 0 : value;
    };
    OrderManager.prototype.setStoreGrandTotalFormat = function (total) {
        if (this.store.menu.settings.checkoutTrimDecimalsMode === "rounddown") {
            this.order.grandTotal = Math.floor(this.order.total - this.order.discount + this.order.handling);
        }
    };
    OrderManager.prototype.getStoreGrandTotalPrecision = function (currency) {
        if (!currency)
            return 1;
        var c = currency.slice(0, 2);
        if ("HK" === c) {
            return 1;
        }
        else if ("SG" === c) {
            return 2;
        }
        else if ("MY" === c) {
            //return "MYR";
        }
        else if ("CN" === c) {
            return 1;
        }
        else if ("TW" === c) {
            //return "TWD";
        }
        else if ("MO" === c) {
            //return "MOP";
        }
        else if ("US" === c) {
            return 2;
        }
        else if ("CA" === c) {
            return 2;
        }
        else if ("IN" === c) {
            //return "INR";
        }
        else if ("VN" === c) {
            //return "VND";
        }
        else if ("AU" === c) {
            return 2;
        }
        else if ("NZ" === c) {
            //return "NZD";
        }
        else if ("KR" === c) {
            //return "KRW";
        }
        else if ("ID" === c) {
            //return "IDR";
        }
        else if ("TH" === c) {
            //return "THB";
        }
        return 1;
    };
    OrderManager.prototype.getHandling = function () {
        var handling = 0;
        if (this.isEmpty()) {
            return handling;
        }
        handling += this.handleTakeawayCharge();
        handling += this.handleDeliveryCharge();
        return handling;
    };
    OrderManager.prototype.getHandlingSafe = function (order, store, first) {
        var handling = 0;
        if (this.isEmpty()) {
            return handling;
        }
        handling += this.handleTakeawayChargeSafe(order, store, first);
        handling += this.handleDeliveryChargeSafe(order, store, first);
        return handling;
    };
    OrderManager.prototype.getMasterStore = function () {
        if (!this.master)
            return this.store;
        return this.master;
    };
    OrderManager.prototype.handleTakeawayCharge = function () {
        var handling = 0;
        if (this.order.type == "takeaway" || (this.order.type == "kiosk" && this.order.takeout)) {
            var pickupCharge = 0;
            var pickupItemCharge_1 = 0;
            var master = this.getMasterStore();
            if (master.menu) {
                pickupCharge = master.menu.pickupCharge;
                pickupItemCharge_1 = master.menu.pickupItemCharge;
            }
            handling = pickupCharge;
            if (pickupItemCharge_1 > 0) {
                this.order.orderitems.forEach(function (oi) {
                    var mainItem = OrderItem.getMainItem(oi);
                    if (mainItem.packing && mainItem.packing > 0) {
                        oi.handling = MathUtils.round(oi.quantity * pickupItemCharge_1 * mainItem.packing, 2);
                        handling += oi.handling;
                    }
                    // else
                    // {
                    //     //if do not set packing, default
                    //     oi.handling = MathUtils.round(oi.quantity * pickupItemCharge, 2);
                    //     handling += oi.handling;
                    // }
                });
            }
            this.order.orderitems.forEach(function (oi) {
                var mainItem = OrderItem.getMainItem(oi);
                if (mainItem.handling) {
                    oi.handling = MathUtils.round(oi.quantity * mainItem.handling, 2);
                    handling += oi.handling;
                }
            });
            handling = MathUtils.round(handling, 2);
            //this.order.grandTotal = Number((this.order.total + this.order.handling).toFixed(2));
            console.log("order pickupItemCharge", this.count * pickupItemCharge_1);
            console.log("order pickupCharge", pickupCharge);
        }
        return handling;
    };
    OrderManager.prototype.handleDeliveryCharge = function () {
        var handling = 0;
        if (this.order.type == "delivery") {
            var deliveryCharge = 0;
            var master = this.getMasterStore();
            if (master.menu) {
                deliveryCharge = master.menu.deliveryCharge;
            }
            handling = deliveryCharge;
            //this.order.grandTotal = Number((this.order.total + this.order.handling).toFixed(2));
            console.log("order deliveryCharge", deliveryCharge);
        }
        return handling;
    };
    OrderManager.prototype.handleTakeawayChargeSafe = function (order, store, first) {
        var handling = 0;
        if (order.type == "takeaway" || (order.type == "kiosk" && order.takeout)) {
            var pickupCharge = 0;
            var pickupItemCharge_2 = 0;
            if (store.menu) {
                pickupItemCharge_2 = store.menu.pickupItemCharge;
                if (first) {
                    pickupCharge = store.menu.pickupCharge;
                }
            }
            handling = pickupCharge;
            if (pickupItemCharge_2 > 0) {
                this.order.orderitems.forEach(function (oi) {
                    oi.handling = MathUtils.round(oi.quantity * pickupItemCharge_2, 2);
                    handling += oi.handling;
                });
            }
            order.orderitems.forEach(function (oi) {
                var mainItem = OrderItem.getMainItem(oi);
                if (mainItem.handling) {
                    oi.handling = MathUtils.round(oi.quantity * mainItem.handling, 2);
                    handling += oi.handling;
                }
            });
            handling = MathUtils.round(handling, 2);
            //this.order.grandTotal = Number((this.order.total + this.order.handling).toFixed(2));
            //console.log("order pickupItemCharge", count * pickupItemCharge);
            //console.log("order pickupCharge", pickupCharge);
        }
        return handling;
    };
    OrderManager.prototype.handleDeliveryChargeSafe = function (order, store, first) {
        var handling = 0;
        if (order.type == "delivery") {
            var deliveryCharge = 0;
            if (store.menu && first) {
                deliveryCharge = store.menu.deliveryCharge;
            }
            handling = deliveryCharge;
            //this.order.grandTotal = Number((this.order.total + this.order.handling).toFixed(2));
            console.log("order deliveryCharge", deliveryCharge);
        }
        return handling;
    };
    OrderManager.prototype.calculateExTax = function (rule, item, oIQty, taxBreakDown) {
        var amount1 = this.addSubTax(rule.rate1, rule.alias1, item, oIQty, taxBreakDown);
        var amount2 = this.addSubTax(rule.rate2, rule.alias2, item, oIQty, taxBreakDown);
        var amount3 = this.addSubTax(rule.rate3, rule.alias3, item, oIQty, taxBreakDown);
        // let result = amount1 + amount2 + amount3;
        // let percent = MathUtils.round( result / item.price, 2);
        // console.log("item "+ item.name + ", tax: " + percent *100 + "%");
    };
    OrderManager.prototype.addSubTax = function (taxRate, taxAlias, item, oIQty, taxBreakDown) {
        var amount = oIQty * item.quantity * (item.price - item.discount) * taxRate; //NOT handle discounted price
        if (!amount)
            return 0;
        var now = taxBreakDown.get(taxAlias);
        if (!now)
            now = 0;
        taxBreakDown.set(taxAlias, now + amount);
        return amount;
    };
    OrderManager.prototype.getServiceCharge = function () {
        var serviceCharge = 0;
        var master = this.getMasterStore();
        if (master.menu && master.menu.serviceCharge && master.menu.serviceCharge > 0) {
            var serviceChargeRate = (master.menu.serviceCharge / 100);
            //serviceChargeRate = MathUtils.round(serviceChargeRate, 2);
            var serviceChargeAmount = MathUtils.round(this.order.grandTotal * serviceChargeRate, 2);
            this.order.grandTotal = MathUtils.round(this.order.grandTotal + serviceChargeAmount, 2);
            console.log("order service charge amount and rate", serviceChargeAmount, serviceChargeRate);
            return serviceChargeAmount;
        }
        else
            return 0;
    };
    OrderManager.prototype.getTax = function () {
        var _this = this;
        var tax = 0;
        var master = this.getMasterStore();
        if (master.menu && master.menu.taxRules && master.menu.taxRules.length > 0) {
            var taxRules = master.menu.taxRules;
            taxRules = taxRules.filter(function (r) { return !r.inclusive; });
            var rules_1 = new Map();
            taxRules.forEach(function (rule) {
                if (rule.itemType && !rules_1.has(rule.itemType))
                    rules_1.set(rule.itemType, rule);
            });
            console.log("Tax Rules: ", rules_1);
            var taxBreakDown_1 = new Map();
            this.order.orderitems.forEach(function (oi) {
                var items = OrderItem.getFlattenItems(oi, true);
                for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                    var item = items_1[_i];
                    //if (!item.taxGroup) continue;
                    var itemType = "";
                    if (!item.taxGroup) {
                        itemType = "all";
                    }
                    else
                        itemType = item.taxGroup;
                    if (rules_1.has(itemType)) {
                        var rule = rules_1.get(itemType);
                        _this.calculateExTax(rule, item, oi.quantity, taxBreakDown_1);
                    }
                    else {
                        console.log("Missing Tax Type: ", itemType);
                    }
                }
            });
            this.order.taxes = [];
            taxBreakDown_1.forEach(function (value, key, map) {
                var amount = MathUtils.round(value, 2);
                var line = {
                    name: key,
                    value: amount
                };
                tax += value;
                _this.order.taxes.push(line);
            });
            tax = MathUtils.round(tax, 2);
            this.order.grandTotal = MathUtils.round(this.order.grandTotal + tax, 2);
            console.log("order taxes", this.order.taxes);
        }
        else {
            if (master.menu) {
                tax = master.menu.tax;
            }
            if (!tax || !Number(tax)) {
                tax = 0;
            }
            if (tax > 0) {
                var gst = (this.order.grandTotal / (100 + tax)) * tax;
                tax = MathUtils.round(gst, 2);
            }
        }
        console.log("order tax", tax);
        return tax;
    };
    OrderManager.prototype.getTaxSafe = function (order, store) {
        var _this = this;
        var tax = 0;
        if (store.menu && store.menu.taxRules && store.menu.taxRules.length > 0) {
            var taxRules = store.menu.taxRules;
            var rules_2 = new Map();
            taxRules.forEach(function (rule) {
                if (rule.itemType && !rules_2.has(rule.itemType))
                    rules_2.set(rule.itemType, rule);
            });
            var taxBreakDown_2 = new Map();
            order.orderitems.forEach(function (oi) {
                var items = OrderItem.getFlattenItems(oi, true);
                for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
                    var item = items_2[_i];
                    if (!item.taxGroup)
                        continue;
                    var itemType = item.taxGroup;
                    if (rules_2.has(itemType)) {
                        var rule = rules_2.get(itemType);
                        _this.calculateExTax(rule, item, oi.quantity, taxBreakDown_2);
                    }
                    else {
                        console.log("Missing Tax Type: ", itemType);
                    }
                }
            });
            order.taxes = [];
            taxBreakDown_2.forEach(function (value, key, map) {
                var amount = MathUtils.round(value, 2);
                var line = {
                    name: key,
                    value: amount
                };
                tax += value;
                order.taxes.push(line);
            });
            tax = MathUtils.round(tax, 2);
            order.grandTotal = MathUtils.round(order.grandTotal + tax, 2);
            console.log("order taxes", order.taxes);
        }
        else {
            if (store.menu) {
                tax = store.menu.tax;
            }
            if (!tax || !Number(tax)) {
                tax = 0;
            }
            if (tax > 0) {
                var gst = (order.grandTotal / (100 + tax)) * tax;
                tax = MathUtils.round(gst, 2);
            }
        }
        console.log("order tax", tax);
        return tax;
    };
    OrderManager.prototype.calculateOrderItem = function (orderitem) {
        var total = 0;
        for (var _i = 0, _a = orderitem.items; _i < _a.length; _i++) {
            var item = _a[_i];
            var q = item.quantity;
            //if (!q || q < 0) q = 1;
            var t = item.price * q;
            total += MathUtils.round(t, 2);
        }
        orderitem.total = MathUtils.round(total, 2);
    };
    OrderManager.prototype.getOrderNumber = function (orderNumber, index) {
        if (index == -1)
            return orderNumber;
        var suffix = this.letter.charAt(index);
        return orderNumber + suffix;
    };
    OrderManager = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [])
    ], OrderManager);
    return OrderManager;
}());
export { OrderManager };
//# sourceMappingURL=order-manager.js.map